<template>
  <div id="app">
    <main-nav />
    <router-view></router-view>
  </div>
</template>

<script>
import Firebase from 'firebase'
import MainNav from './components/MainNav'
import { dbThemesRef, dbOrdersRef } from './firebaseConfig'

export default {
  name: 'App',
  components: {
    'main-nav': MainNav
  },
  created () {
    this.$store.dispatch('setThemesRef', dbThemesRef),
    this.$store.dispatch('setOrdersRef', dbOrdersRef)

    Firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch('autoSignIn', user)
      }
    })
  }
}
</script>

<style lang="scss">
@import './static/main.scss';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
input {
  border: 1px solid #ddd;
  padding: 16px;
  margin: 8px;
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue